// Dependencies
import * as React from 'react';

// Utils
import { comp } from '../betslip/util/utils';

// Styles
import styles from './title.module.css';

export enum Header {
  H1 = 'h1',
  H2 = 'h2',
  H3 = 'h3',
  H4 = 'h4',
  SPAN = 'span',
}

export interface IProps {
  after?: JSX.Element;
  before?: JSX.Element;
  className?: string;
  gtmEventLabel?: string;
  noPadding?: boolean;
  regressionTag?: string;
  smallHeaderOnMobile?: boolean;
  style?: React.CSSProperties;
  tag?: Header;
  testId?: string;
  title: string;
}

const Title: React.FC<IProps> = ({
  after = null,
  before = null,
  className = '',
  gtmEventLabel = null,
  noPadding = false,
  regressionTag = null,
  smallHeaderOnMobile = false,
  tag = Header.H2,
  testId = null,
  title,
  ...rest
}) => {
  if (!title) {
    return null;
  }

  const titleWithAttribs = React.createElement(
    tag,
    {
      'data-testid': testId,
      'data-gtm-event-label': gtmEventLabel,
      'data-regression-tag': regressionTag,
      className: comp(
        className || '',
        noPadding ? styles.noPadding : '',
        smallHeaderOnMobile ? styles.smallHeaderOnMobile : ''
      ),
      ...rest
    },
    title
  );

  return (
    <>
			{before}
			{titleWithAttribs}
			{after}
		</>);

};

export default Title;